// 書類の状態
export const DOCSTATUS = {
  IN_PREPARATION: -1,
  REJECTES: -10,
  APPROVED: 0,
  // それ以外はロールでどこまで承認済か判断する

  APPLYING: {
    OFFICE: 10,
    OFFECE_CHIEF: 11,
    VICE_CHAIRMAN: 20,
    CHAIRMAN: 21,
  },
}

export const expenseItems = [
  { name: '調査研究費', id: 1, color: '#808000' },
  { name: '研修費', id: 2, color: '#ffff00' },
  { name: '広報費', id: 3, color: '#ff00ff' },
  { name: '公聴費', id: 4, color: '#c0c0c0' },
  { name: '要請・陳情活動費', id: 5, color: '#00ffff' },
  { name: '会議費', id: 6, color: '#00ff00' },
  { name: '資料作成費', id: 7, color: '#ff0000' },
  { name: '資料購入費', id: 8, color: '#0000ff' },
  { name: '人件費', id: 9, color: '#008000' },
  { name: '事務所費', id: 10, color: '#41B883' },
]

export const expenseItemsYokohama = [
  { name: '調査研究費', id: 1, color: '#808000' },
  { name: '研修費', id: 2, color: '#ffff00' },
  { name: '広報費', id: 3, color: '#ff00ff' },
  { name: '広聴費', id: 4, color: '#c0c0c0' },
  { name: '要請・陳情活動費', id: 5, color: '#00ffff' },
  { name: '会議費', id: 6, color: '#00ff00' },
  { name: '資料作成費', id: 7, color: '#ff0000' },
  { name: '資料購入費', id: 8, color: '#0000ff' },
  { name: '人件費', id: 9, color: '#008000' },
  { name: '事務所費', id: 10, color: '#41B883' },
  { name: '事務費', id: 11, color: '#800080' },
]

export const expenseItemsOsaka = [
  { name: '調査研究費', id: 1, color: '#808000' },
  { name: '研修費', id: 2, color: '#ffff00' },
  { name: '広聴広報費', id: 3, color: '#ff00ff' },
  { name: '要請陳情等活動費', id: 4, color: '#00ffff' },
  { name: '会議費', id: 5, color: '#00ff00' },
  { name: '資料作成費', id: 6, color: '#ff0000' },
  { name: '資料購入費', id: 7, color: '#0000ff' },
  { name: '事務所費', id: 8, color: '#41B883' },
  { name: '事務費', id: 9, color: '#41B883' },
  { name: '人件費', id: 10, color: '#008000' },
]

export const expenseItemsToda = [
  { name: '研修費', id: 1, color: '#808000' },
  { name: '調査費', id: 2, color: '#ffff00' },
  { name: '資料作成費', id: 3, color: '#ff00ff' },
  { name: '資料購入費', id: 4, color: '#c0c0c0' },
  { name: '広報費', id: 5, color: '#00ffff' },
  { name: '広聴費', id: 6, color: '#00ff00' },
  { name: '人件費', id: 7, color: '#ff0000' },
  { name: '事務所費', id: 8, color: '#0000ff' },
  { name: 'その他', id: 9, color: '#008000' },
]
